import React, { useState, useEffect, useRef, memo, forwardRef } from "react";
import { PurityApi } from "../../api/PurityApi.js";
import { getAddToCart, getBranchId } from "utility/HeaderConfig.js";
import { Link } from "react-router-dom";
import CategorysMenu from "./CategorysMenu.js";
import logo from "../../images/Logo.png";
import { useCartContext } from "context/UseCartContext.js";
import toast, { Toaster } from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import Noimg from "../../images/no_img.jpg";
import RemoveCart from "components/RemoveCart.js";
import { getProduct } from "api/ProductApi.js";
import moment from "moment";
import { filterFormatFromDate, filterFormatToDate } from "utility/Constant.js";
import TopbarMenus from "./TopbarMenus.js";

// ── Language Context (exported so other components can use) ──────────────────
export const LangContext = React.createContext({ lang: "en", t: (k) => k });

export function useTranslate() {
  const { lang } = React.useContext(LangContext);
  return (key) => key;
}

// ── Customer Support FAB ─────────────────────────────────────────────────────
function CustomerSupportFAB() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9998 }}>
      {open && (
        <div style={{
          position: "absolute", bottom: "calc(100% + 12px)", right: 0,
          background: "#fff", borderRadius: 16,
          boxShadow: "0 20px 60px rgba(0,0,0,.18)",
          border: "1px solid #f0e9fa",
          overflow: "hidden", minWidth: 230,
          animation: "ejScaleIn .2s cubic-bezier(.16,1,.3,1)",
        }}>
          <div style={{ background: "#4f3267", padding: "12px 16px" }}>
            <p style={{ color: "#fff", fontWeight: 700, fontSize: 13, margin: 0 }}>Talk to our Experts</p>
          </div>
          <a href="/BookAnAppointment" style={{
            display: "flex", alignItems: "center", gap: 12,
            padding: "14px 16px", textDecoration: "none",
            borderBottom: "1px solid #f5f0fd", transition: "background .14s",
          }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#faf5ff"}
            onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
          >
            <div style={{ width: 38, height: 38, borderRadius: "50%", background: "#ede9fe", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="#4f3267" strokeWidth="2" width="18" height="18">
                <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/>
              </svg>
            </div>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#1c1c1e" }}>Live Video Call</span>
          </a>
          <a href="https://api.whatsapp.com/send?phone=+919244336446&text=Hi, I want to chat about jewellery!"
            target="_blank" rel="noreferrer"
            style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", textDecoration: "none", transition: "background .14s" }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#f0fdf4"}
            onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
          >
            <div style={{ width: 38, height: 38, borderRadius: "50%", background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg viewBox="0 0 24 24" fill="#25D366" width="20" height="20">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.09.539 4.05 1.48 5.757L0 24l6.395-1.677A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.817 9.817 0 01-5.006-1.37l-.359-.214-3.796.995.993-3.663-.235-.374A9.818 9.818 0 1112 21.818z"/>
              </svg>
            </div>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#1c1c1e" }}>Chat on Whatsapp</span>
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Customer Support"
        style={{
          width: 52, height: 52, borderRadius: "50%",
          background: "#4f3267", border: "none", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 4px 20px rgba(79,50,103,.4)",
          transition: "transform .2s, background .2s",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.08)"; e.currentTarget.style.background = "#7517b4"; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.background = "#4f3267"; }}
      >
        {open ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
          </svg>
        )}
      </button>
    </div>
  );
}

// ── Main Component ───────────────────────────────────────────────────────────
const MyComponent = ({ branch }) => {
  const [recentGoldRate, setRecentGoldRate] = useState({ metaProdTypeName: "Gold", rate: "N/A", unitType: "", purity: "" });
  const [recentSilverRate, setRecentSilverRate] = useState({ metaProdTypeName: "Silver", rate: "N/A", unitType: "" });
  const [viewCart, setViewCart] = useState([]);
  const [total, setTotal] = useState(0);
  const [showModal, setShowModal] = useState("");
  const [cartOpen, setCartOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1440
  );
  const lang = "en";
  const t = (key) => key;
  const cartRef = useRef(null);

  const { data, branchId, dispatch, dayClosed } = useCartContext();

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isDesktop = windowWidth > 1024;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (cartRef.current && !cartRef.current.contains(e.target)) setCartOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => { getProductRate(); }, []); // eslint-disable-line

  const getProductRate = async () => {
    const fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    const toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    const filterData = {
      branch: getBranchId(),
      createdAtFrom: filterFormatFromDate(fromDate),
      createdAtTo: filterFormatToDate(toDate),
    };
    const todayMetalRate = await PurityApi(filterData);
    if (todayMetalRate.errorCode === undefined) {
      let gf = false, sf = false;
      todayMetalRate.response.forEach((item) => {
        const n = item.metaProdTypeName?.toLowerCase();
        if (n === "gold" && item.purity.includes("22") && !gf) {
          item.purity = "22K"; setRecentGoldRate(item); gf = true;
        } else if (n === "silver" && !sf) {
          setRecentSilverRate(item); sf = true;
        }
      });
    }
  };

  useEffect(() => { viewCartList(); }, [data, branchId]); // eslint-disable-line

  const viewCartList = () => {
    const newArray = getAddToCart()
      ? JSON.parse(getAddToCart()).filter((c) => c.branchId === getBranchId())
      : [];
    if (newArray.length === 0) { setViewCart([]); setTotal(0); return; }
    let dataList = [];
    newArray.forEach((element, index) => {
      getProduct(10, { branch: getBranchId(), id: element.id, beforeCreatedAt: dayClosed }).then(() => {
        dataList.push(element);
        if (dataList.length - 1 === index) {
          setTotal(newArray.reduce((a, i) => a + Math.trunc(i.total || 0), 0));
          setViewCart([...dataList]);
        }
      });
    });
  };

  const removeItemFromCart = (code) => {
    const result = JSON.parse(getAddToCart()).filter((i) => i.productCode !== code);
    reactLocalStorage.set("CartList", JSON.stringify(result));
    dispatch({ type: "ADD", payload: result });
    setTotal(result.reduce((a, i) => a + Math.trunc(i.total || 0), 0));
    setViewCart(result);
    toast.success("Removed from bag", { duration: 2000, position: "top-right", style: { background: "#1a1a1a", color: "#fff", borderRadius: "10px", fontSize: "13px" } });
    setShowModal("");
  };

  const cartCount = data?.filter((c) => c.branch === getBranchId())?.length || JSON.parse(getAddToCart() || "[]").length;

  const fmtRate = (r) => {
    const v = r.onlineRate > 0 ? r.onlineRate : r.rate;
    if (!v || v === "N/A") return "N/A";
    return `₹${v}${r.unitType ? `/${r.unitType}` : ""}`;
  };

  const iconBtn = {
    position: "relative", display: "flex", alignItems: "center", justifyContent: "center",
    width: 40, height: 40, background: "none", border: "none",
    borderRadius: 999, color: "#1c1c1e", cursor: "pointer", transition: "background .14s",
  };

  return (
    <LangContext.Provider value={{ lang, t }}>
      <Toaster position="top-right" />

      <nav style={{
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        zIndex: 999,
        background: "rgba(255,255,255,0.97)",
        borderBottom: scrolled ? "1px solid #e5e5ea" : "1px solid transparent",
        boxShadow: scrolled ? "0 1px 16px rgba(0,0,0,0.07)" : "none",
        transition: "border-color 0.24s, box-shadow 0.24s",
      }}>
        <div style={{
          maxWidth: 1440, margin: "0 auto", padding: "0 16px",
          height: 72, display: "flex", alignItems: "center",
          justifyContent: "space-between", gap: 8, flexWrap: "nowrap",
        }}>
          {/* Hamburger — mobile only */}
          <button
            onClick={() => setMobileMenuOpen((v) => !v)}
            aria-label="Menu"
            style={{
              display: isDesktop ? "none" : "flex", alignItems: "center", justifyContent: "center",
              width: 38, height: 38, padding: 7, background: "none",
              border: "none", borderRadius: 8, color: "#1c1c1e",
              cursor: "pointer", flexShrink: 0,
            }}
            className="ej-hamburger-btn"
          >
            {mobileMenuOpen ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
              </svg>
            )}
          </button>

          {/* LOGO */}
          <Link to="/" style={{ flexShrink: 0, textDecoration: "none", display: "flex", alignItems: "center" }}>
            <img src={logo} alt="AVM Jewellers" style={{ height: 75, width: 75, objectFit: "cover", objectPosition: "center", borderRadius: 10 }} />
            <span style={{ marginLeft: 10, display: "flex", flexDirection: "column", lineHeight: 1.15 }} className="ej-logo-text">
              <span style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontSize: 15, fontWeight: 500, color: "#4f3267", letterSpacing: "0.18em", textTransform: "uppercase" }}>
                Jewellers
              </span>
            </span>
          </Link>

          <div style={{ flex: 1 }} />

          {/* Right controls */}
          <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
            {/* Metal rates — desktop */}
            <div style={{
              display: isDesktop ? "flex" : "none", alignItems: "stretch", borderRadius: 12, overflow: "hidden",
              background: "#fff", flexShrink: 0, border: "1px solid #e8d9f8",
              boxShadow: "0 2px 8px rgba(79,50,103,.08)",
            }} className="ej-rates-badge">
              <div style={{ background: "linear-gradient(135deg,#6d28d9,#9333ea)", padding: "0 12px", display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#fff", opacity: 0.9, display: "inline-block", boxShadow: "0 0 0 2px rgba(255,255,255,.35)", animation: "livePulse 1.4s ease infinite" }} />
                <span style={{ fontSize: 10, fontWeight: 800, color: "#fff", letterSpacing: ".1em", textTransform: "uppercase" }}>Live</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 12px", borderLeft: "1px solid #f0e9fa" }}>
                <div style={{ width: 26, height: 26, borderRadius: "50%", background: "linear-gradient(135deg,#f5c842,#c9890f)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 1px 4px rgba(200,140,12,0.35)" }} aria-hidden="true">
                  <span style={{ color: "#fff", fontSize: 8, fontWeight: 900, letterSpacing: "-.3px" }}>GOLD</span>
                </div>
                <div style={{ lineHeight: 1.25 }}>
                  <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: "#6c6c70" }}>Gold 22K</div>
                  <div style={{ fontSize: 12, fontWeight: 900, color: "#1c1c1e", whiteSpace: "nowrap" }}>{fmtRate(recentGoldRate)}</div>
                </div>
              </div>
              <div style={{ width: 1, background: "#f0e9fa", alignSelf: "stretch" }} />
              <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 12px" }}>
                <div style={{ width: 26, height: 26, borderRadius: "50%", background: "linear-gradient(135deg,#e0e0e0,#909090)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 1px 4px rgba(0,0,0,0.15)" }} aria-hidden="true">
                  <span style={{ color: "#fff", fontSize: 7, fontWeight: 900, letterSpacing: "-.3px" }}>SILVR</span>
                </div>
                <div style={{ lineHeight: 1.25 }}>
                  <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: "#6c6c70" }}>Silver</div>
                  <div style={{ fontSize: 12, fontWeight: 900, color: "#1c1c1e", whiteSpace: "nowrap" }}>{fmtRate(recentSilverRate)}</div>
                </div>
              </div>
            </div>

            <TopbarMenus lang={lang} t={t} />

            {/* Wishlist icon */}
            <Link to="/wishlist" aria-label="Wishlist" style={{ ...iconBtn, textDecoration: "none" }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
              </svg>
            </Link>

            {/* Cart */}
            <div style={{ position: "relative" }} ref={cartRef}>
              <button onClick={() => setCartOpen((v) => !v)} aria-label="Cart" style={iconBtn}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                  <line x1="3" y1="6" x2="21" y2="6"/>
                  <path d="M16 10a4 4 0 01-8 0"/>
                </svg>
                {cartCount > 0 && (
                  <span style={{ position: "absolute", top: 2, right: 2, minWidth: 17, height: 17, padding: "0 4px", background: "#8a0bb8", color: "#fff", fontSize: 9.5, fontWeight: 700, lineHeight: "17px", borderRadius: 999, textAlign: "center" }}>
                    {cartCount}
                  </span>
                )}
              </button>

              {cartOpen && (
                <div style={{
                  position: "absolute", top: "calc(100% + 12px)", right: 0,
                  width: 360, maxHeight: "80vh", background: "#fff",
                  border: "1px solid #e5e5ea", borderRadius: 20,
                  boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
                  overflow: "hidden", display: "flex", flexDirection: "column",
                  animation: "ejScaleIn .2s cubic-bezier(.16,1,.3,1)", zIndex: 9999,
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px" }}>
                    <span style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 18, fontWeight: 600, color: "#3a065f" }}>Shopping Bag</span>
                    <span style={{ fontSize: 12, color: "#9685aa" }}>{cartCount} {cartCount === 1 ? "item" : "items"}</span>
                  </div>
                  <div style={{ height: 1, background: "#f2f2f7", flexShrink: 0 }} />

                  {viewCart.length > 0 ? (
                    <>
                      <div style={{ overflowY: "auto", flex: 1, padding: "10px 16px", display: "flex", flexDirection: "column", gap: 10 }}>
                        {viewCart.map((item, i) => (
                          <div key={i} style={{ display: "flex", gap: 12, padding: 10, borderRadius: 10, background: "#f0ebf7" }}>
                            <img src={item.images?.includes("@#@") && item.images !== "@#@" ? item.images.split("@#@")[0] : Noimg}
                              alt={item.title} style={{ width: 62, height: 62, objectFit: "cover", borderRadius: 8, border: "1px solid #f2f2f7", flexShrink: 0 }} />
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <p style={{ fontSize: 12.5, fontWeight: 500, color: "#3e0279", margin: "0 0 4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.title}</p>
                              <span style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#b80bb6", marginBottom: 5 }}>₹{Math.trunc(item.total)}</span>
                              <button onClick={() => setShowModal(item.skv)} style={{ fontSize: 11, color: "#98989d", background: "none", border: "none", padding: 0, textDecoration: "underline", cursor: "pointer" }}>Remove</button>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ height: 1, background: "#f2f2f7" }} />
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px" }}>
                        <span style={{ fontSize: 13.5, fontWeight: 500, color: "#3a065f" }}>Subtotal</span>
                        <span style={{ fontSize: 14, fontWeight: 600, color: "#b80bb6" }}>₹ {Math.trunc(total)}</span>
                      </div>
                      <Link to="/CartPage" onClick={() => setCartOpen(false)}
                        style={{ display: "block", margin: "8px 16px 16px", padding: 12, background: "#4f3267", color: "#fff", fontSize: 13, fontWeight: 600, letterSpacing: ".05em", textDecoration: "none", textAlign: "center", borderRadius: 9 }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#7517b4")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#4f3267")}
                      >View Bag & Checkout</Link>
                    </>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 24px", gap: 10, textAlign: "center" }}>
                      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#4f3267" strokeWidth="1.2">
                        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                        <line x1="3" y1="6" x2="21" y2="6"/>
                        <path d="M16 10a4 4 0 01-8 0"/>
                      </svg>
                      <p style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 18, fontWeight: 500, color: "#4f3267", margin: 0 }}>Your bag is empty</p>
                      <Link to="/ProductList" onClick={() => setCartOpen(false)}
                        style={{ fontSize: 12, fontWeight: 600, color: "#d994f5", textDecoration: "none", letterSpacing: ".05em", textTransform: "uppercase", borderBottom: "1px solid #f5e4f8" }}>
                        Explore Collections
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile slide menu */}
        <div style={{
          maxHeight: mobileMenuOpen ? "90vh" : 0,
          overflow: "hidden",
          transition: "max-height 0.4s cubic-bezier(.16,1,.3,1)",
          background: "#fff",
          borderTop: mobileMenuOpen ? "1px solid #f2f2f7" : "none",
        }}>
          <CategorysMenu isMobile onClose={() => setMobileMenuOpen(false)} lang={lang} t={t} />
        </div>
      </nav>

      {showModal && (
        <>
          <RemoveCart setShowModal={() => setShowModal("")} showModal={showModal} removeItemFromCart={removeItemFromCart} />
          <div style={{ opacity: 0.4, position: "fixed", inset: 0, zIndex: 40, background: "#000" }} />
        </>
      )}

      <style>{`
        @keyframes ejScaleIn { from { opacity:0; transform:scale(.96) translateY(-4px); } to { opacity:1; transform:scale(1) translateY(0); } }
        @keyframes livePulse { 0%,100% { opacity:0.9; transform:scale(1); } 50% { opacity:0.5; transform:scale(1.3); } }
        @media (max-width: 480px) {
          .ej-logo-text { display: none !important; }
        }
          .ej-mobile-rates-strip {
          align-items: center;
          gap: 0;
          background: linear-gradient(135deg,#fdf8ee,#fff9f0);
          border-top: 1px solid #f0ddb0;
          border-bottom: 1px solid #f0ddb0;
          padding: 6px 0 6px 12px;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          justify-content: flex-start;
          position: fixed;
          left: 0;
          right: 0;
          top: 121px;
          z-index: 997;
        }
        .ej-mobile-rates-strip::-webkit-scrollbar { display: none; }
        @media (min-width: 601px) and (max-width: 1024px) {
          .ej-mobile-rates-strip {
            justify-content: center;
            padding: 6px 12px;
          }
        }
        @media (max-width: 360px) {
          .ej-mobile-rate-item { padding: 0 6px; gap: 3px; }
          .ej-mobile-rate-label { font-size: 8.5px; }
        }
        .ej-mobile-rate-item {
          display: flex; align-items: center; gap: 5px;
          padding: 0 10px; white-space: nowrap;
        }
        .ej-mobile-rate-dot {
          width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
        }
        .ej-dot-gold22 { background: linear-gradient(135deg,#f5c842,#c9890f); }
        .ej-dot-gold18 { background: linear-gradient(135deg,#f5c842,#9a6f0a); }
        .ej-dot-silver { background: linear-gradient(135deg,#e0e0e0,#909090); }
        .ej-mobile-rate-label {
          font-size: 10px; font-weight: 700; color: #6c6c70;
          letter-spacing: .06em; text-transform: uppercase;
        }
        .ej-mobile-rate-val {
          font-size: 11px; font-weight: 900; color: #1c1c1e;
        }
        .ej-mobile-rate-divider {
          width: 1px; height: 20px; flex-shrink: 0;
          background: linear-gradient(to bottom,transparent,#e8c96a,transparent);
        }

      `}</style>

      <div className="ej-desktop-categories-bar" style={{ width: "100%", background: "#4F3267", position: "fixed", top: "73px", zIndex: 998 }}>
        <CategorysMenu lang={lang} t={t} />
      </div>
       {!isDesktop && (
       <div className="ej-mobile-rates-strip">
            <span className="ej-mobile-rate-item">
              <span className="ej-mobile-rate-dot ej-dot-gold22" />
              <span className="ej-mobile-rate-label">Gold 22K</span>
              <span className="ej-mobile-rate-val">{fmtRate(recentGoldRate)}</span>
            </span>
            <span className="ej-mobile-rate-divider" />
            <span className="ej-mobile-rate-item">
              <span className="ej-mobile-rate-dot ej-dot-silver" />
              <span className="ej-mobile-rate-label">Silver 90%</span>
              <span className="ej-mobile-rate-val">{fmtRate(recentSilverRate)}</span>
            </span>
          </div>
       )}


      {/* Customer Support FAB */}
      <CustomerSupportFAB />
    </LangContext.Provider>
  );
};

export default memo(forwardRef(MyComponent));